export default __webpack_public_path__ + "static/media/freetrialbg.26191056.svg";